// Get the navbar
const navbar = document.getElementById('subnav');

if (navbar) {
  const sticky = navbar.offsetTop;

  // Add the sticky class to the navbar when you reach its scroll position. Remove "sticky" when you leave the scroll position
  const scrollNav = () => {
    if (window.scrollY >= sticky) {
      navbar.classList.add('scrolled');
    } else {
      navbar.classList.remove('scrolled');
    }
  };

  window.onscroll = () => {
    scrollNav();
  };
}
